import { render, staticRenderFns } from "./modal-employee-history.component.vue?vue&type=template&id=1b461c1a&"
import script from "./modal-employee-history.component.vue?vue&type=script&lang=ts&"
export * from "./modal-employee-history.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports